import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

export const postAlbum = async (data) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/album`, data);
  return request?.data;
};

export const getAlbumById = async (id) => {
  const request = await axios.get(`${HOST_API_KEY}/album/${id}`);
  return request?.data;
};

export const getUserAlbums = async (userId) => {
  const request = await axios.get(`${HOST_API_KEY}/album/user/${userId}`);
  return request?.data;
};

export const updateAlbumById = async (id, data) => {
  const request = await axiosInstanceWithToken.put(`${HOST_API_KEY}/album/update/${id}`, data);
  return request?.data;
};
